//#region src/helpers/has-children.ts
/**
* Type guard to check if the given Item has a non-empty array of children.
* Returns true if `currentItem` has a `children` property that is an array with at least one element.
*/
var hasChildren = (currentItem) => {
	return "children" in currentItem && Array.isArray(currentItem.children) && currentItem.children.length > 0;
};
//#endregion
export { hasChildren };

//# sourceMappingURL=has-children.js.map